import { Col, InputNumber, Row, Space, Typography } from "antd";
import React from "react";

const { Text } = Typography;

export const TapeTab = ({ tapeColorCount, setTapeColorCount }) => {
  //handles tape colors
  const handleTapeColorCount = (value) => {
    setTapeColorCount(value);
  };
  return (
    <>
      <Row
        style={{
          paddingRight: 45,
          paddingLeft: 45,
          paddingBottom: 45,
        }}
        align="middle"
        gutter={[2, 5]}
      >
        <Col span={24}>
          <Space>
            <Text>How many colors?</Text>
            <InputNumber style={{ width: "100%" }} value={tapeColorCount} min={0} max={3} onChange={handleTapeColorCount} placeholder="0" />
          </Space>
        </Col>
      </Row>
    </>
  );
};
